<style lang="scss" scoped>
/deep/ {
  .el-input-group__append {
    background: #fff;
    padding: 0;
    width: 40px;
    .el-button {
      min-width: 40px;
      padding: 0;
      margin: 0;
    }
  }
}
.input {
  width: 240px;
}
.line {
  height: 45px;
  background: #eee;
  margin-bottom: 10px;
  line-height: 45px;
  color: #4a4a4a;
  .iconfont {
    font-size: 24px;
    vertical-align: middle;
  }
  .blue {
    color: #173bcf;
  }
  .btn {
    display: inline-block;
    padding: 0 15px;
    height: 100%;
    width: 44px;
    box-sizing: border-box;
  }
}
.pager {
  text-align: center;
}
/deep/ {
  .el-pagination button:disabled,
  .el-pager li,
  .el-pagination .btn-prev,
  .el-pagination .btn-next {
    background: transparent;
  }
}
.img {
  width: 160px;
}
.tags {
  /deep/ .el-tag {
    margin: 0 10px 10px 0;
  }
}
/deep/ .search-icon {
  font-size: 16px !important;
}
</style>

<template>
  <div>
    <AlertTips />
    <div class="clearfix mb10">
      <div class="input fr">
        <el-input placeholder="请输入内容" v-model="key" class="input-with-select">
          <el-button slot="append" icon="search-icon el-icon-search" @click="search"></el-button>
        </el-input>
      </div>
    </div>
    <div v-for="(item,index) in list" :key="item.qrCodeId">
      <div class="line clearfix">
        <div class="fl">
          <el-popover placement="bottom" width="160">
            <img class="img" :src="item.qrCodeUrl" alt />
            <p class="alignr" @click="handlerDownload(item.qrCodeUrl)">右键保存二维码图片</p>
            <span class="icon blue mr20 pointer" slot="reference">
              <i class="iconfont iconerweima"></i>
              查看二维码
            </span>
          </el-popover>
          <span>{{item.name}}</span>
        </div>
        <div class="fr">
          <span>{{momentutc(item.createdDate)}}</span>
          <span class="ml20">
            <el-checkbox v-model="item.onlySubscribe" @change="changeSub($event,item.qrCodeId)">仅关注</el-checkbox>
          </span>
          <div class="btn">
            <span @click="change(index, item.qrCodeId)" v-show="!item.onlySubscribe">
              <i class="el-icon-caret-bottom blue" v-show="!item.show"></i>
              <i class="el-icon-caret-top blue" v-show="item.show"></i>
            </span>
          </div>
        </div>
      </div>
      <el-collapse-transition v-if="!item.onlySubscribe">
        <div v-show="item.show">
          <div class="tags">
            <el-tag
              type="info"
              size="small"
              color="#fff"
              effect="plain"
              v-for="tag in getTags(index)"
              :key="tag.name"
            >{{tag.name}}</el-tag>
          </div>
          <wxEditor :ref="`wxEditor${item.qrCodeId}`"></wxEditor>
          <div class="clearfix mt10 mb10">
            <el-button class="fr" type="primary" size="small" @click="save(item.qrCodeId)">保存</el-button>
          </div>
        </div>
      </el-collapse-transition>
    </div>
    <div class="mt40">
      <el-pagination
        class="pager"
        layout="prev, pager, next"
        :page-size="pageSize"
        :current-page.sync="page"
        :total="total"
        @current-change="changePage"
        hide-on-single-page
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import wxEditor from '@/components/wxEditor';
import AlertTips from '@/components/alertTips';
import store from 'store';
export default {
  components: {
    wxEditor,
    AlertTips,
  },
  props: ['id'],
  computed: {},
  data() {
    return {
      key: '',
      show: false,
      show2: false,
      checked: '',
      page: 1,
      pageSize: 10,
      total: 0,
      list: [],
      chooseList: [],
      downloadurl: '',
      nickName: store.get('oaNickName'),
    };
  },
  async mounted() {
    await this.getData();
  },
  methods: {
    handlerDownload(url) {
      let filename = url.split('/');
      filename = filename[filename.length - 1];
      var alink = document.createElement('a');
      alink.href = url;
      alink.download = filename;
      alink.target = '_blank';
      alink.click();
    },

    getTags(idx) {
      let arr = this.chooseList[idx];
      let ret = [];
      for (let key in arr) {
        if (key == 'customTags') {
          ret = arr[key];
        }
      }
      return ret;
    },
    async change(i, id) {
      let res = await this.$http.get(
        `/api/${this.id}/channel/args-qrcode/${id}`,
      );
      if (res.replyType && res.material) {
        this.$refs[`wxEditor${id}`][0].setData(res);
      }
      this.list[i].show = !this.list[i].show;
      this.chooseList[i] = res;
    },
    async changePage(val) {
      this.page = val;
      await this.getData();
    },
    async getData(search) {
      let res = search
        ? await this.$http.get(
            `/api/${this.id}/channel/args-qrcodes?key=${this.key}&page=${this.page}&size=${this.pageSize}`,
          )
        : await this.$http.get(
            `/api/${this.id}/channel/args-qrcodes?page=${this.page}&size=${this.pageSize}`,
          );
      res.list = res.list.map(v => {
        v.show = false;
        return v;
      });
      this.list = res.list;
      this.total = res.totalSize;
    },
    async changeSub(val, qrCodeId) {
      await this.$http.put(
        `/api/${this.id}/channel/args-qrcode/${qrCodeId}/onlysubscribe`,
      );
    },
    async save(id) {
      let data = this.$refs[`wxEditor${id}`][0].postData();
      let res = await this.$http.put(
        `/api/${this.id}/channel/args-qrcode/${id}`,
        data,
      );
      if (res) {
        this.$message.success('保存成功');
        await this.getData();
      }
    },
    async search() {
      this.getData(1);
    },
  },
};
</script>
